import DashboardPage from "./dashboard-pages/DashboardPage";
import DocumentErrorPage from "./dashboard-pages/DocumentErrorPage";
import StatsDashboardPage from "./dashboard-pages/StatsDashboardPage";
import SystemNotificationPage from "./dashboard-pages/SystemNotificationPage";
import OperationalDashboardPage from "./dashboard-pages/OperationalDashboardPage";
import TaxPayerPage from "./dashboard-pages/TaxPayerPage";
import UserPage from "./dashboard-pages/UserPage";
import UserTaxPayerPage from "./dashboard-pages/UserTaxPayerPage";
import SifenIncidentsPage from "./dashboard-pages/SifenIncidentsPage";

import SupportEmailSettingsPage from "./dashboard-pages/SupportEmailSettingsPage";
import { SHOW_SIFEN_INCIDENTS } from "./config/features";

interface Route {
  path: string;
  exact?: boolean | undefined;
  name: string;
  component?: any;
}

interface RouteMap {
  [index: string]: Route;
}

const routes: RouteMap = {
  ...(SHOW_SIFEN_INCIDENTS ? {
    supportEmailSettings: { path: "/support_email_settings/", name: "Correo de soporte", exact: true, component: SupportEmailSettingsPage },
    sifenIncidents: {
      path: "/sifen_incidents/",
      name: "Incidencias SIFEN",
      exact: true,
      component: SifenIncidentsPage,
    },
  } : {}),
  dashboard: {
    path: "/dashboard/",
    name: "Inicio",
    exact: true,
    component: DashboardPage,
  },
  users: {
    path: "/users/",
    name: "Usuarios",
    exact: true,
    component: UserPage,
  },
  taxPayers: {
    path: "/tax_payers/",
    name: "Contribuyentes",
    exact: true,
    component: TaxPayerPage,
  },
  userTaxPayers: {
    path: "/tax_payers/:id(\\d+)/users/",
    name: "Usuarios de Contribuyente",
    exact: false,
    component: UserTaxPayerPage,
  },
  stats: {
    path: "/stats/",
    name: "Estadísticas",
    exact: true,
    component: StatsDashboardPage,
  },
  operations: {
    path: "/operations/",
    name: "Monitoreo SIFEN",
    exact: true,
    component: OperationalDashboardPage,
  },
  documentErrors: {
    path: "/document_errors/",
    name: "Biblioteca Errores",
    exact: true,
    component: DocumentErrorPage,
  },
  systemNotifications: {
    path: "/system_notifications/",
    name: "Avisos",
    exact: true,
    component: SystemNotificationPage,
  },
};

export const getRoutePath = (key: string) => {
  return routes[key].path;
};
export const getRouteName = (key: string) => {
  return routes[key].name;
};

export default routes;
